// extracted by mini-css-extract-plugin
export default {"step_card":"StepCard_step_card__8V9QW","icon":"StepCard_icon__8TDm1"};